import React, { useState, useEffect } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";
import ButtonLayout from "../common/button/ButtonLayout";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { setUser } from "../../services/loginService";
import { COOKIE_KEY, DECRYPT_KEY, DEBI_ROLE, CODE_COOKIE, MORE_INFO_TEXT, AUTH_TEXT, REDIRECT_URL, CLICK_HERE_LABEL } from "../../utils/constants/GlobalConstants"

const Login = () => {
  const [codeVerifier, setCodeVerifier] = useState("");
  const [authCode, setAuthCode] = useState("");
  const navigate = useNavigate();
  const PING_URL = process.env.REACT_APP_PING_URL;
  const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
  const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
  const encryptF = Cookies.get(COOKIE_KEY);
  useEffect(() => {
    const verifier = generateCodeVerifier();
    setCodeVerifier(verifier);
  }, []);
  useEffect(() => {
    if (encryptF) {
      navigate("/debi-tool/home");
    }
  }, [encryptF, navigate]);

  const generateCodeVerifier = () => {
    const verifier =
      crypto.getRandomValues(new Uint8Array(32)) &&
      Array.from(crypto.getRandomValues(new Uint8Array(32)))
        .map((x) => x.toString(16).padStart(2, "0"))
        .join("");
    return verifier;
  };

  const generateCodeChallenge = (codeVerifier) => {
    const wordArray = CryptoJS.enc.Utf8.parse(codeVerifier);
    const hashed = CryptoJS.SHA256(wordArray);
    const base64Url = CryptoJS.enc.Base64url.stringify(hashed);
    return base64Url;
  };

  const redirectToPingID = (event) => {
    if (event === "click") {
      Cookies.set(CODE_COOKIE, codeVerifier);
      const codeChallengeLAtest = generateCodeChallenge(codeVerifier);
      if (codeChallengeLAtest) {
        const authorizationUrl = `${PING_URL}/as/authorization.oauth2?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=openid%20profile%20groups%20email%20phone&code_challenge=${codeChallengeLAtest}&code_challenge_method=S256`;
        window.location.href = authorizationUrl;
      }
    }
  };
  
  const getAuthToken = async (authToken) => {
    const getRoleUrl = `${PING_URL}/idp/userinfo.openid`;
    if (authToken) {
      const axiosClient = axios.create();
      axiosClient.defaults.headers = {
        Authorization: `Bearer ${authToken}`,
      };
      try {
        const response = await axiosClient
          .post(getRoleUrl)
          .then((response) => response.data)
          .catch((err) => {
            throw err;
          });
        if (response) {
          let storedObj = response;
          if (Array.isArray(response.groups)) {
            let hasPartsAdmin = response.groups.find(item => item === DEBI_ROLE.PARTS_ADMIN);
            storedObj.group = hasPartsAdmin ? DEBI_ROLE.PARTS_ADMIN : response.groups[0];
          } else {
            storedObj.group = response.groups;
          }
          const responseString = JSON.stringify(storedObj);
          const hashResponse = CryptoJS.AES.encrypt(
            responseString,
            DECRYPT_KEY
          ).toString();
          const today = new Date();
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);
          Cookies.set(COOKIE_KEY, hashResponse, { expires: tomorrow });
          if (response?.groups) {
            try {
              setUser({ username: response?.email });
            } catch (error) {
              console.log(error.message);
            }
          }
          navigate("/debi-tool/home");
          window.location.reload();
        }
      } catch (error) {
        throw error;
      }
    }
  };

  const exchangeCodeForToken = async (authorizationCode) => {
    const verifier = codeVerifier ? codeVerifier : Cookies.get(CODE_COOKIE);
    setCodeVerifier(verifier);
    Cookies.remove(CODE_COOKIE);
    const tokenUrl = `${PING_URL}/as/token.oauth2`;
    const body = new URLSearchParams({
      code: authorizationCode,
      grant_type: "authorization_code",
      redirect_uri: REDIRECT_URI,
      code_verifier: verifier,
      client_id: CLIENT_ID,
    });

    try {
      if (verifier) {
        const response = await axios.post(tokenUrl, body);
        if (response.data.access_token) {
          getAuthToken(response.data.access_token);
        }
      }
    } catch (error) {
      console.error("Error exchanging code", error);
    }
  };

  const handleAuthCallback = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (code) {
      setAuthCode(code);
      exchangeCodeForToken(code);
    }
  };

  useEffect(() => {
    if (window.location.search.includes("code=")) {
      handleAuthCallback();
    }
  });

  return (
    <div>
      {!authCode && (
        <>

          <div className="login-btn">
            <ButtonLayout
              testid="Login with PingID"
              color="primary"
              label="BATTERY DEBI LOGIN"
              onClickBtn={() => redirectToPingID("click")}
            />
          </div>

          <div className="login-desc">
            {AUTH_TEXT}{MORE_INFO_TEXT}
            <div className="click-btn" onClick={() => { window.open(REDIRECT_URL, '_blank') }} testid="link"> {CLICK_HERE_LABEL}</div>
          </div>

        </>
      )}
    </div>
  );
};

export default Login;
